"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.numberOfAuthors = void 0;
// `numberOfAuthors` is determined and set by the Node.js postinstall script.
// `numberOfAuthors` is consumed by the browser-side code.
exports.numberOfAuthors = 0;
//# sourceMappingURL=numberOfAuthors.js.map